import { CloseOutlined } from '@ant-design/icons'
import { Button, Image, Result } from 'antd'
import { useLocation, useNavigate } from 'react-router'
import { Link } from 'react-router-dom'
import IpRestrictedImage from '../../Assets/Images/IpRestricted.svg'

const IpRestricted = ({ dispatch }: any) => {
  const location = useLocation()
  const navigate = useNavigate()

  if (location?.state?.internal_nav !== true)
    return (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary">
            <Link to="/">Go Home</Link>
          </Button>
        }
      />
    )
  return (
    <div style={{ padding: 20, height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
        <CloseOutlined
          style={{ fontSize: 25 }}
          onClick={() =>
            dispatch({
              type: 'auth/userSignOut',
              onSuccess: navigate('/login'),
            })
          }
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          alignItems: 'center',
          flex: 1,
          gap: 20,
        }}
      >
        <div>
          <Image src={IpRestrictedImage} preview={false} />
        </div>
        <div
          style={{
            width: '50%',
            display: 'flex',
            justifyContent: 'center',
            fontSize: 18,
            color: 'var(--neutral-200)',
          }}
        >
          <span>It appears that you are using unauthorized network</span>
        </div>
        <div style={{ width: '50%', textAlign: 'center', color: 'var(--neutral-100)' }}>
          <span style={{ textAlign: 'center', display: 'block', fontSize: 13 }}>
            Please connect with the authorized network and try again, If the situation persists,
          </span>
          <span style={{ textAlign: 'center', display: 'block', fontSize: 13 }}>
            please contact the network admistrator
          </span>
        </div>
        <div>
          <Button type="primary" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        </div>
      </div>
    </div>
  )
}

export default IpRestricted
